import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsFormDataConnectionsRoute } from '@jira/router-routes__admin-pages-proforma-routes/src/globalSettingsFormDataConnectionsRoute.tsx';
import JiraAdminProformaDataConnectionsEntryPoint from '@jira/proforma__jira-admin-proforma-data-connections/src/JiraAdminProformaDataConnectionsEntryPoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const jiraAdminProformaDataConnectionsPageEntryPoint = createPageEntryPoint({
	main: JiraAdminProformaDataConnectionsEntryPoint,
});

export const globalSettingsFormDataConnectionsRouteEntry: Route = createEntry(
	globalSettingsFormDataConnectionsRoute,
	() => ({
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation],

		entryPoint() {
			return jiraAdminProformaDataConnectionsPageEntryPoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
